import { Tag, Popconfirm } from "antd";
import { useMyBookings } from "./modules/useMyBookings";
import { useModal } from "../../../../admin/bookingList/modules/useModal";
import { BookingModal } from "../../../../admin/bookingList/molecules/bookingModal";

export function MyBookings() {
  const { bookings, cancelBooking } = useMyBookings();
  const { showModal, handleCancel, isModalVisible, selectedBooking } =
    useModal();

  return (
    <div>
      <h1>My Bookings</h1>
      {bookings.length > 0 ? (
        <ul>
          {bookings.map((booking) => (
            <div className="row">
              <div className="col-md-6 bs">
                <div className="d-flex flex-column">
                  <div className="d-flex justify-content-between align-items-end">
                    <div>
                      <h1>{booking.room}</h1>
                      <p>
                        <strong>Booking ID: </strong> {booking.bookingId}
                      </p>
                      <p>
                        <strong>Check In: </strong>
                        {booking.fromdate}
                      </p>
                      <p>
                        <strong>Check Out: </strong>
                        {booking.todate}
                      </p>
                      <p>
                        <strong>Total Amount: </strong>
                        {booking.totalamount}
                      </p>
                      <p>
                        <strong>Total Day: </strong>
                        {booking.totaldays}
                      </p>
                      <p>
                        <strong>Status: </strong>{" "}
                        {booking.status === "cancelled" ? (
                          <Tag color="orange">CANCELLED</Tag>
                        ) : (
                          <Tag color="green">CONFIRMED</Tag>
                        )}
                      </p>
                      {/* Add more booking details as needed */}
                    </div>
                    <div className="d-flex gap-2">
                      {booking.status !== "cancelled" && (
                        <Popconfirm
                          title="Are you sure to cancel this booking?"
                          onConfirm={() =>
                            cancelBooking(booking.bookingId, booking.roomid)
                          }
                          onCancel={() => {}}
                          okText="Yes"
                          cancelText="No"
                        >
                          <button className="btn btn-danger mb-2" type="button">
                            Cancel Booking
                          </button>
                        </Popconfirm>
                      )}
                      <button
                        className="btn btn-info mb-2"
                        type="button"
                        onClick={() => showModal(booking)}
                      >
                        View Booking
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
          {selectedBooking && (
            <BookingModal
              selectedBooking={selectedBooking}
              isModalVisible={isModalVisible}
              handleCancel={handleCancel}
            />
          )}
        </ul>
      ) : (
        <p>No bookings found.</p>
      )}
    </div>
  );
}
